module.exports = __webpack_public_path__ + "static/media/preview_logo.67753fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/preview_logo.png
// module id = 784
// module chunks = 0